import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGamepad, faUser } from "@fortawesome/free-solid-svg-icons";

const Navigation = ({ userObj }) => (
    <nav>
        <ul style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
            <li>
                <Link to="/" style={{ marginRight: 10 }}>
                    <FontAwesomeIcon icon={faGamepad} color={"#ffe4e4"} size="3x" />
                </Link>
            </li>
            <li>
                <Link to="/lck" style={{ marginRight: 10 }}>
                    <img src={process.env.PUBLIC_URL + "/LCK_2021_logo.png"}
                        alt="Logo"
                        style={{ width: "52.5px", height: "42px" }} />
                </Link>
            </li>
            <li>
                <Link to="/lpl" style={{ marginRight: 10 }}>
                    <img src={process.env.PUBLIC_URL + "/LPL_2020.png"}
                        alt="Logo"
                        style={{ width: "52.5px", height: "42px" }} />
                </Link>
            </li>
            <li>
                <Link to="/lec" style={{ marginRight: 10 }}>
                    <img src={process.env.PUBLIC_URL + "/LEC_2019.png"}
                        alt="Logo"
                        style={{ width: "52.5px", height: "42px" }} />
                </Link>
            </li>
            <li>
                <Link to="/lcs" style={{ marginRight: 10 }}>
                    <img src={process.env.PUBLIC_URL + "/lcs logo.png"}
                        alt="Logo"
                        style={{ width: "52.5px", height: "42px" }} />
                </Link>
            </li>
            <li>
                <Link
                    to="/profile"
                    style={{
                        marginLeft: 10,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        fontSize: 12,
                    }}
                >
                    <FontAwesomeIcon icon={faUser} color={"#ffe4e4"} size="3x" />
                    <span style={{ marginTop: 10 }}>
                        {userObj.displayName
                            ? `${userObj.displayName}의 Profile`
                            : "Profile"}
                    </span>
                </Link>
            </li>
        </ul>
    </nav>
);
export default Navigation;